import {
	weddingsRootUrl as weddingsRootUrlDefault,
	weddingsRootUrlK8,
} from '../../../settings';

export default function weddingsRootUrl() {
	if (process.env.K8) {
		return weddingsRootUrlK8;
	}

	return weddingsRootUrlDefault;
}
